export default function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
}



// WEBPACK FOOTER //
// ./node_modules/moment/src/lib/utils/is-array.js